var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 168,
    viewBox: "0 0 220 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 88,
    r: 80,
    fill: "#EBEBEB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 26,
    cy: 28,
    r: 8,
    fill: "#E0E0E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 198,
    cy: 134,
    r: 6,
    fill: "#E0E0E1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 25,
    cy: 146,
    r: 10,
    fill: "#E0E0E1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 210,
    cy: 54,
    r: 10,
    fill: "#E0E0E1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 191,
    cy: 19,
    r: 7,
    fill: "#E0E0E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 33.25,
    width: 138,
    height: 110,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0366 50.3346C62.0366 50.1045 62.225 49.918 62.4574 49.918H157.543C157.775 49.918 157.963 50.1045 157.963 50.3346C157.963 50.5648 157.775 50.7513 157.543 50.7513H62.4574C62.225 50.7513 62.0366 50.5648 62.0366 50.3346Z",
    fill: "#E0E0E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0366 69.293C62.0366 69.0628 62.225 68.8763 62.4574 68.8763H157.543C157.775 68.8763 157.963 69.0628 157.963 69.293C157.963 69.5231 157.775 69.7096 157.543 69.7096H62.4574C62.225 69.7096 62.0366 69.5231 62.0366 69.293Z",
    fill: "#E0E0E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0366 88.2513C62.0366 88.0212 62.225 87.8346 62.4574 87.8346H157.543C157.775 87.8346 157.963 88.0212 157.963 88.2513C157.963 88.4814 157.775 88.668 157.543 88.668H62.4574C62.225 88.668 62.0366 88.4814 62.0366 88.2513Z",
    fill: "#E0E0E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0366 107.21C62.0366 106.98 62.225 106.793 62.4574 106.793H157.543C157.775 106.793 157.963 106.98 157.963 107.21C157.963 107.44 157.775 107.626 157.543 107.626H62.4574C62.225 107.626 62.0366 107.44 62.0366 107.21Z",
    fill: "#E0E0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0366 126.168C62.0366 125.938 62.225 125.751 62.4574 125.751H157.543C157.775 125.751 157.963 125.938 157.963 126.168C157.963 126.398 157.775 126.585 157.543 126.585H62.4574C62.225 126.585 62.0366 126.398 62.0366 126.168Z",
    fill: "#E0E0E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0366 59.9167C62.0366 58.9962 62.7901 58.25 63.7195 58.25H76.3415C77.271 58.25 78.0244 58.9962 78.0244 59.9167V124.917C78.0244 125.837 77.271 126.583 76.3415 126.583H63.7195C62.7901 126.583 62.0366 125.837 62.0366 124.917V59.9167Z",
    fill: "#E0E0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.683 85.75C88.683 84.8295 89.4364 84.0833 90.3659 84.0833H102.988C103.917 84.0833 104.671 84.8295 104.671 85.75V124.917C104.671 125.837 103.917 126.583 102.988 126.583H90.3659C89.4364 126.583 88.683 125.837 88.683 124.917V85.75Z",
    fill: "#E0E0E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.329 64.9167C115.329 63.9962 116.083 63.25 117.012 63.25H129.634C130.564 63.25 131.317 63.9962 131.317 64.9167V124.917C131.317 125.837 130.564 126.583 129.634 126.583H117.012C116.083 126.583 115.329 125.837 115.329 124.917V64.9167Z",
    fill: "#E0E0E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.976 79.9167C141.976 78.9962 142.729 78.25 143.659 78.25H156.281C157.21 78.25 157.963 78.9962 157.963 79.9167V124.917C157.963 125.837 157.21 126.583 156.281 126.583H143.659C142.729 126.583 141.976 125.837 141.976 124.917V79.9167Z",
    fill: "#E0E0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2988 81.5846L68.7176 79.2368C69.5028 78.8966 70.4174 79.0936 70.9929 79.7269L95.2796 106.451C95.9872 107.23 97.177 107.327 98.0017 106.674L122.962 86.8987C123.531 86.4477 124.3 86.3407 124.971 86.6193L149.302 96.724C149.733 96.9032 150.214 96.9257 150.66 96.7876L156.701 94.918",
    stroke: "#C6C6C6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSkeleton);
export default __webpack_public_path__ + "static/media/chart-skeleton.25e0592115f8954a0861013036d9ec10.svg";
export { ForwardRef as ReactComponent };